import { render } from "./FooterVac.vue?vue&type=template&id=1a6d9142&lang=true"
import script from "./FooterVac.vue?vue&type=script&lang=js"
export * from "./FooterVac.vue?vue&type=script&lang=js"

import "./FooterVac.vue?vue&type=style&index=0&id=1a6d9142&lang=scss"

import exportComponent from "C:\\Users\\MrBin\\Desktop\\Front\\vac2\\VAC\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__